import React from 'react';
import AccountPreference from './AccountPreference';

export default class AccountPreferenceIndex extends React.Component {

    render() {



        return (
            <div className="general-setting" >
                <AccountPreference {...this.props} />
            </div>
        );
    }
}
